
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import langSwitch from "../layout/components/lang-switch.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { permitCountry } from "@common/src/utils/tools";
const user = namespace("user");
const app = namespace("app");
const dashboard = namespace("dashboard");
const store = namespace("store");
const setting = namespace("setting");
const common_base = namespace("common_base");
@Component({
  components: { langSwitch }
})
export default class TopHeader extends Vue {
  @user.State userData;
  @user.Action loginOut;
  @user.State selectedOrgCode;
  @user.State storePayInfo;
  @user.Action setCurrentStore;
  @user.Action getMobileCode;
  @user.Action queryStorePayInfo;
  @dashboard.Action getUnreadNoticeCount;
  @dashboard.State unreadNoticeCount;
  @app.State orderPushState;
  @app.Mutation setOrderPushState;
  @app.State appType;
  @app.State storeLabelIconList;
  @app.State appTypeLabelIcon;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @store.Action deleteStoreData;
  @setting.State serviceModeDesc;
  @common_base.State currencyUnit;
  @common_base.State currencySymbol;
  dayjs = dayjs;
  permitCountry = permitCountry;
  t = t;
  nameIsExpand: boolean = false;
  orgCode: string = "";
  searchText: string = "";
  verificationCode: string = "";

  logOut() {
    this.loginOut();
  }
  created() {
    this.orgCode = this.selectedOrgCode;
    this.getUnreadNoticeCount();
    this.init();
  }
  async init() {
    this.queryStorePayInfo({ orgCode: this.orgCode });
  }
  get name() {
    return this.userData.firstName ? this.userData.firstName : "";
  }
  get role() {
    try {
      return this.userData.roleList.map(item => item.roleName).join();
    } catch (e) {
      return "-";
    }
  }

  async handleStoreChange(val) {
    await this.setCurrentStore({
      orgCode: val
    });
    this.$router.push(`/index?storeId=${val}`);
  }
  handleLinkNoticePage() {
    this.$router.push("/notice");
  }
  downCounterTime: any = 0;
  shwoDeleteData: boolean = false;
  deleteDataStep: number = 1;
  downCounter: number = 5;
  hasSendCode: boolean = false;
  phoneCodeCountDownNum = 60;
  phoneCode: string = "";
  verificationCodeToken = "";
  timer: any = 0;
  handleShowDeleteData() {
    this.deleteDataStep = 1;
    this.shwoDeleteData = true;
    this.deleteDataStartCounter();
  }
  deleteDataStartCounter() {
    this.downCounterTime = setInterval(() => {
      if (this.downCounter-- <= 0) {
        clearInterval(this.downCounterTime);
      }
    }, 1000);
  }
  handleDeleteDataNext() {
    this.deleteDataStep = 2;
  }
  handleDeleteData() {
    if (!this.verificationCodeToken) {
      return this.$message.error(t("v260.please-get-the-verification-code-first"));
    }
    if (!this.phoneCode) {
      return this.$message.error(t("v260.please-enter-the-mobile-phone-verification-code"));
    }
    this.btnStartLoading();
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    this.deleteStoreData({
      verificationCode: this.phoneCode,
      verificationCodeToken: this.verificationCodeToken
    })
      .then(() => {
        loading.close();
        this.$message.success(t("v260.the-system-has-resumed-initialization"));
        setTimeout(() => {
          const { href } = this.$router.resolve("/index?random=" + Date.now());
          location.href = href;
        }, 1500);
      })
      .finally(() => {
        this.btnStopLoading();
        loading.close();
      });
  }
  handleDeleteDataClose() {
    this.downCounter = 5;
    this.phoneCodeCountDownNum = 60;
    this.hasSendCode = false;
    this.phoneCode = "";
    this.verificationCodeToken = "";
    clearInterval(this.downCounterTime);
    clearInterval(this.timer);
  }
  async getVerificationCode() {
    if (this.hasSendCode) {
      return;
    }
    this.getMobileCode({
      validationCodeType: "4"
    }).then(
      data => {
        this.verificationCodeToken = data.data.validationToken;
        this.hasSendCode = true;
        this.timer = setInterval(() => {
          if (--this.phoneCodeCountDownNum === 0) {
            clearInterval(this.timer);
            this.hasSendCode = false;
            this.phoneCodeCountDownNum = 60;
          }
        }, 1000);
        this.$message.success(t("v260.the-verification-code-has-been-sent-to-the"));
      },
      data => {
        this.$message.error(data.message);
      }
    );
  }
  goUpgrade() {
    this.$router.push("/upgrade/index");
  }
  enterSearch() {
    this.$router.push(`/study/online-study/?class=0&search=${this.searchText}&className=`);
  }
}
